import React from "react";
import {observer} from "mobx-react";
import {IntersectionObserver} from "../../../core/components/intersection-observer/intersection-observer";
import {RelatedEntitiesWidgetAsync} from "../../../widgets/related-entities-widget/components/related-entities-widget.async";
import classNames from "classnames";
import styles from "../styles/competitor-container.module.scss";

export const CompetitorContainerRelatedEntities = observer(({controller}) => {
  const {state, device} = controller;
  const {competitorId} = state;
  const {isSmallView} = device;

  return isSmallView ? <IntersectionObserver className={classNames(styles.related_entities)}>
    <RelatedEntitiesWidgetAsync competitorId={competitorId}/>
  </IntersectionObserver> : null
});